import actionTypes from './index';

export default (
  windowsWithInvalidConfigurationsModalOpen,
  windowsWithInvalidConfigurations,
) =>
  ({
    type: actionTypes.CONTROL_WINDOWS_WITH_INVALID_CONFIGURATIONS_MODAL,
    payload: {
      windowsWithInvalidConfigurationsModalOpen,
      windowsWithInvalidConfigurations,
    },
  });
